import { message } from 'antd'
import DocumentsApi from '../../../../api/Documents'
import { TaskSystemApi } from '../../../../api/TaskSystem'
import AddTaskSystem from '../../../../components/Operations/TaskSystem/AddTaskSystem/AddTaskSystem'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { MODAL_TYPE_EDIT, MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import qs from 'query-string'
import React from 'react'
import { isEmpty, get, pick } from 'lodash'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import { withRouter } from 'react-router-dom'

const formRef = React.createRef()
const docsApi = new DocumentsApi()
AddTaskSystemCont.propTypes = {}

function AddTaskSystemCont(props) {
  const key = get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const enquiryID = values.enquiryID
  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW

  console.log({ key })
  const { fetch, fetching, object: task, setObject: setTask } = useFetchObject(
    () => TaskSystemApi.read(key),
    false,
    [key],
    isEmpty(key)
  )

  const [updating, updateFunc] = useSubmit(TaskSystemApi.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(TaskSystemApi.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/operations/task-system/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const taskDB = await updateFunc({
      ...pick(task, ['_key', '_id', '_rev']),
      ...values,
    })
    if (taskDB) setTask(taskDB)
  }

  const [removing, removeFunc] = useSubmit(TaskSystemApi.remove)

  async function remove() {
    const removed = await removeFunc({
      ...pick(task, ['_key', '_rev', '_id']),
    })
    if (removed)
      props.history.replace({
        pathname: `/operations/task-system/`,
      })
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('task', task.status),
    [task.status, isEmpty(task.status)]
  )
  const [submittingOperation, submitOperation] = useSubmit(TaskSystemApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const taskDB = await submitOperation({
      status: operation,
      ...pick(task, ['_key', '_rev', '_id']),
    })
    if (taskDB) {
      setTask(taskDB)
    }
    hide()
  }

  const isNew = type === MODAL_TYPE_NEW
  // const isUpdatable = actions.find(a => a.key === 'update')
  const isUpdatable = true
  const isConfirmed = ['Confirmed'].includes(task.status)

  return (
    <AddTaskSystem
      {...{
        task,
        fetching,
        fetch,
        key,
        submit,
        submitting,
        update,
        updating,
        remove,
        removing,
        actions,
        fetchingActions,
        fetchActions,
        isNew,
        isUpdatable,
        submittingOperation,
        handleActions,
        isConfirmed,
        type,
        formRef,
        enquiryID,
      }}
    />
  )
}

export default withRouter(AddTaskSystemCont)
